<template>
  <div class="adblock mt-0">
    <div class="img">
      Google AdSense<br>
      336 x 280
    </div>
  </div>
</template>

<script>
export default {};
</script>
